import { CityGroup } from '../types'
import { useState } from 'react'

export function useCitySelection(initialSelection: number[] = []) {
  const [selectedCities, setSelectedCities] =
    useState<number[]>(initialSelection)

  const toggleCity = (cityId: number) => {
    setSelectedCities((prev) =>
      prev.includes(cityId)
        ? prev.filter((id) => id !== cityId)
        : [...prev, cityId]
    )
  }

  const toggleGroup = (group: CityGroup) => {
    const allGroupCitiesSelected = group.cities.every((cityId) =>
      selectedCities.includes(cityId)
    )

    if (allGroupCitiesSelected) {
      setSelectedCities((prev) =>
        prev.filter((id) => !group.cities.includes(id))
      )
    } else {
      setSelectedCities((prev) => {
        const newCities = group.cities.filter(
          (cityId) => !prev.includes(cityId)
        )
        return [...prev, ...newCities]
      })
    }
  }

  const isGroupChecked = (group: CityGroup) =>
    group.cities.length > 0 &&
    group.cities.every((cityId) => selectedCities.includes(cityId))

  const isGroupIndeterminate = (group: CityGroup) => {
    const selectedCount = group.cities.filter((cityId) =>
      selectedCities.includes(cityId)
    ).length
    return selectedCount > 0 && selectedCount < group.cities.length
  }

  const selectAll = (cityIds: number[]) =>
    setSelectedCities((prev) => {
      const added = cityIds.filter((id) => !prev.includes(id))
      return [...prev, ...added]
    })

  const deselectAll = (cityIds: number[]) =>
    setSelectedCities((prev) => prev.filter((id) => !cityIds.includes(id)))

  const clearSelection = () => setSelectedCities([])

  const setSelection = (cityIds: number[]) => {
    setSelectedCities(cityIds)
  }

  return {
    selectedCities,
    toggleCity,
    toggleGroup,
    isGroupChecked,
    isGroupIndeterminate,
    selectAll,
    deselectAll,
    clearSelection,
    setSelection,
  }
}
